import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_FAILURE,
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_SUCCESS,
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST,
  GET_THERAPY_PLANNING_DISCHARGE_REQUEST_2_0,
} = therapyPlanningAction;

function* updateTherapyPlanningDischargeDate(requestPayload: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapyPlanningService.updateTherapyPlanningDischargeDate,
      requestPayload?.payload
    );
    if (response?.status === 200) {
      yield put({ type: UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_SUCCESS, payload: response.data });
      yield put({
        type: GET_THERAPY_PLANNING_DISCHARGE_REQUEST_2_0,
        payload: {
          patientId: requestPayload?.payload?.patientId,
        },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_FAILURE, payload: error });
  }
}

function* updateTherapyPlanningDischargeDateSaga() {
  yield takeEvery(
    UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST,
    updateTherapyPlanningDischargeDate
  );
}

export default updateTherapyPlanningDischargeDateSaga;
